// extracted by mini-css-extract-plugin
export default {"advertDetailInfoParameters":"c-n_fg","advertDetailInfoParameters__header":"c-n_fh","advertDetailInfoParameters__list":"c-n_fi"};